import { makeStyles } from "@material-ui/core";
import * as React from "react";

import { fontFamilies } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    height: 16,
    minWidth: 16,
    padding: "0 4px",
    borderRadius: 9999,
    backgroundColor: theme.palette.semantic["accent/mark"],
    color: theme.palette.semantic["text/inverse"],
    fontFamily: fontFamilies.number,
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1,
  },
}));

export const CountBadge: React.FC<{ count: number }> = ({ count }) => {
  const classes = useStyles();
  if (count <= 0) return null;
  return (
    <span className={classes.badge} aria-label={`未読${count}件`}>
      {count > 99 ? "99+" : count}
    </span>
  );
};
